import { Modal, Checkbox, Button, Tooltip } from "antd";
import { useEffect, useRef, useState } from "react";
import { officeTypeHandle } from "../../OfficeType/state/actions";
import { useDispatch, useSelector } from "react-redux";

const TutorialVedioModal = ({ title, videoUrl, vedioVisible, setVideoVisible, accessVedio, dontShowAgain, setDontShowAgain, openFrom, token }) => {
  const iframeRef = useRef(null);
  const [currentPartIndex, setCurrentPartIndex] = useState(0);
  const { tutorialVedioLinks } = useSelector((state) => state.offerTable);
  const videoParts = Array.isArray(tutorialVedioLinks) ? tutorialVedioLinks?.find((v) => v.functionality === openFrom?.toUpperCase())?.parts || [] : [];

  const { autoPlayHelpVedio } = useSelector((state) => state.account);
  const dispatch = useDispatch();
  const handleClose = () => {
    if (iframeRef.current) {
      iframeRef.current.src = "";
    }
    setVideoVisible(false);
    stopVideo();
    setCurrentPartIndex(0);
  };
  const stopVideo = () => {
    const player = iframeRef.current;
    if (player && player.contentWindow && player.contentWindow.postMessage) {
      player.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', "*");
    }
  };
  const autoplay = accessVedio ? "1" : "0";
  const handleUpdateVedioModal = (e) => {
    setDontShowAgain(e.target.checked);
    let updateData = {};
    const checked = e.target.checked;

    if (openFrom === "CREATE_LISTING") {
      updateData = {
        showVideoDetails: {
          createListing: !checked,
        },
      };
    } else if (openFrom === "OFFER_IMPORT") {
      updateData = {
        showVideoDetails: {
          offerImport: !checked,
        },
      };
    } else if (openFrom === "ACCEPT_OFFER_VIA_RESURE_SIGN") {
      updateData = {
        showVideoDetails: {
          acceptOfferViaResureSign: !checked,
        },
      };
    }
    dispatch(officeTypeHandle.updatePerson(updateData, null, null, token));
    if (checked) {
      handleClose();
    }
  };
  const getLoomEmbedUrl = (shareUrl, autoplay = "0") => {
    if (!shareUrl) return "";
    const id = shareUrl.split("/").pop(); // Extract video ID
    return `https://www.loom.com/embed/${id}?autoplay=${autoplay}`;
  };
  useEffect(() => {
    if (openFrom === "CREATE_LISTING") {
      setDontShowAgain(!autoPlayHelpVedio?.createListing);
    } else if (openFrom === "OFFER_IMPORT") {
      setDontShowAgain(!autoPlayHelpVedio?.offerImport);
    } else if (openFrom === "ACCEPT_OFFER_VIA_RESURE_SIGN") {
      setDontShowAgain(!autoPlayHelpVedio?.acceptOfferViaResureSign);
    }
  }, [autoPlayHelpVedio]);
  useEffect(() => {
    if (vedioVisible && iframeRef.current && videoParts[0]?.url) {
      iframeRef.current.src = getLoomEmbedUrl(videoParts[currentPartIndex]?.url, autoplay);
    }
  }, [vedioVisible, autoplay, videoParts]);

  return (
    <Modal title={<div className="commonModalTitle">{title}</div>} visible={vedioVisible} onCancel={handleClose} footer={null} centered zIndex={1001} width={900}>
      <div style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
        <iframe
          ref={iframeRef}
          src={getLoomEmbedUrl(videoParts[currentPartIndex]?.url, autoplay)}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            borderRadius: 8,
          }}
          frameBorder="0"
          allow="autoplay; fullscreen"
          allowFullScreen
          title={title}
        />
      </div>
      {videoParts.length > 1 && (
        <div style={{ textAlign: "center", marginTop: 16 }}>
          <Button onClick={() => setCurrentPartIndex((i) => Math.max(i - 1, 0))} disabled={currentPartIndex === 0} style={{ marginRight: 8 }}>
            Previous
          </Button>

          <Tooltip title={currentPartIndex === 0 && openFrom === "CREATE_LISTING" ? "Click next to view Part 2 of Create Listing" : ""}>
            <Button type={currentPartIndex === 0 ? "primary" : "default"} onClick={() => setCurrentPartIndex((i) => Math.min(i + 1, videoParts.length - 1))} disabled={currentPartIndex === videoParts.length - 1}>
              Next
            </Button>
          </Tooltip>
        </div>
      )}

      <Checkbox checked={dontShowAgain} onChange={handleUpdateVedioModal} style={{ marginTop: 16 }}>
        Don’t show this again
      </Checkbox>
    </Modal>
  );
};

export default TutorialVedioModal;
